/* Pure Desi — quick wins v1 (2026-09-25). PREVIEW THEME ONLY until Abhi says go.
   Brief: Website/Plan & Audits/2026-09-24-quick-wins-design-ux-motion-v1.md
   Loaded deferred from layout/theme.liquid (one line). Styles: assets/pd-qw.css.

   House rules this file keeps:
   - Bird is never touched. No Bird selector is read or written. "Date chosen" is read from
     the cart's own `Delivery Date` attribute via /cart.js.
   - Nothing here submits the cart form, ticks the terms box or skips /cart (since 28 Sep the terms are
     accepted in the Before-you-pay sheet; pd-diwali-mode.js ticks and hides the box while the sheet exists). The sticky bar
     on /cart only SCROLLS to the next step.
   - Every add stamps properties[_order_type]=diwali-preorder, exactly as the product forms
     do, and refuses to add into an everyday or mixed bag.
   - Adds use /cart/add.js. A /cart/<id>:<qty> link would REPLACE the bag (verified 24 Sep).
   - Each part is wrapped: if one fails, the page is exactly as it was.
   - prefers-reduced-motion: no animation anywhere.
   ES5 on purpose, same as pd-ux.js.

   Parts: D3 boxes first · D5 quotes · U1 one more box · U2 sets · U3 size bar ·
          U4 next-step bar · U5 other sizes · U6 pantry (added 25 Sep) · A1 just added · A2 jar bar · A3 step ticks ·
          A4 card-to-product morph · A5 peek inside · CR1 what the delivery fee covers · CR2 the reason
          by the checkout button · CR3 take the bag from Instagram/Facebook to the browser · CR4 pre-order
          countdown · CR5 the total rolls to its new value (all 26 Sep).
          (D1, D2, D4 are CSS/Liquid/JSON.)
   One exception to "Bird is never touched", since 26 Sep: CR1's "Pick up free instead" taps Bird's
   Store Pickup tab for the shopper, exactly as pd-diwali-mode.js v4.8 taps Shipping. */
(function () {
  'use strict';
  if (window.__pdqw) return;
  window.__pdqw = true;

  var d = document, w = window;
  var RM = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var PROP = { _order_type: 'diwali-preorder' };
  var JAR_CENTS = 9000; /* the early-order gift threshold, as stated on the live cart line */

  /* ---------- helpers ---------- */
  function ready(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function el(tag, cls, html) { var e = d.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* [LP-1] 29 Sep 2026 luxe prices: whole dollars print without ".00" ($41; $14.50 keeps its cents), as the theme's price snippets now do */
  function money(c) { c = Math.round(c); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function is(t) { return !!(d.body && d.body.classList.contains('template-' + t)); }
  function safe(fn) { try { fn(); } catch (e) { if (w.console && console.warn) console.warn('[pd-qw]', e); } }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (_) {} return null; }
  function imgUrl(u, px) { if (!u) return ''; u = String(u).replace(/^https?:/, ''); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px; }
  function short(t) { return String(t || '').replace(/\s+Diwali\s+(Box|Collection)$/i, '').replace(/\s+-\s+Window$/i, '').replace(/\s+Diwali\s+/i, ' '); }
  function gramsOf(txt) { var m = String(txt || '').toLowerCase().match(/([\d.]+)\s*(kg|g)\b/); if (!m) return 0; var n = parseFloat(m[1]); return m[2] === 'kg' ? n * 1000 : n; }
  function sizeText(g) { return g >= 1000 ? (g / 1000) + ' kg' : g + ' g'; }
  /* CF4 (2026-09-25, Abhi: "shorter phone cart, stop the bag jumping") */
  function PHONE() { return !!(w.matchMedia && w.matchMedia('(max-width:767px)').matches); }
  /* In the drawer the two late rows (one more box, pantry) go BELOW the button, in one slot with a
     fixed order, so "Choose date & check out" never moves under a thumb while they load. The slot
     lives inside the drawer's #AjaxCartSubtotal, which the theme re-renders on every quantity
     change; giftRows/pantryRows re-run from the subtotal observer and rebuild it. */
  function drawerSlot(kind) {
    var vc = $('#site-cart-sidebar #ViewCart'); if (!vc) return null;
    var blk = vc.parentNode, nx = blk.nextElementSibling;
    var after = (nx && nx.tagName === 'P') ? nx : blk;
    var box = after.nextElementSibling;
    if (!box || !box.classList.contains('pdqw-below')) { box = el('div', 'pdqw-below'); after.parentNode.insertBefore(box, after.nextSibling); }
    var slot = box.querySelector(':scope > [data-slot="' + kind + '"]');
    if (!slot) {
      slot = el('div', 'pdqw-below__slot'); slot.setAttribute('data-slot', kind);
      if (kind === 'add') box.insertBefore(slot, box.firstChild); else box.appendChild(slot);
    }
    return slot;
  }
  function isDiwaliCollection() { return is('collection') && /^\/collections\/diwali\/?$/.test(location.pathname); }

  /* ---------- catalogue (handles and sizes from the product records, 25 Sep) ---------- */
  var GRAMS = {
    'extra-large-premium-sweet-and-savory-diwali-box': 1500,
    'diwali-special-boondi-ladoo-box': 1000, 'diwali-special-small-motichoor-box': 500, 'extra-small-motichoor-ladoo-box-diwali-special': 250,
    'diwali-special-large-mix-burfi-box': 1000, 'small-mix-burfi-diwali-special-box': 500,
    'diwali-special-large-kaju-box': 1000, 'diwali-special-small-kaju-box': 500,
    'diwali-special-large-sweet-savoury-box': 1000
  };
  var FAMILIES = [
    { heading: 'Same ladoo, other sizes', handles: ['diwali-special-boondi-ladoo-box', 'diwali-special-small-motichoor-box', 'extra-small-motichoor-ladoo-box-diwali-special'] },
    { heading: 'Also in this range', handles: ['diwali-special-large-mix-burfi-box', 'small-mix-burfi-diwali-special-box'] },
    { heading: 'Also in this range', handles: ['diwali-special-large-kaju-box', 'diwali-special-small-kaju-box'] },
    { heading: 'Also in this range', handles: ['extra-large-premium-sweet-and-savory-diwali-box', 'diwali-special-large-sweet-savoury-box'] }
  ];
  var SIZE_LINKS = [
    { g: 1000, label: 'Large 1 kg', href: '/collections/diwali?filter.v.price.gte=30#pd-grid', on: /price\.gte=30/ },
    { g: 500, label: 'Small 500 g', href: '/collections/diwali?filter.v.price.gte=20&filter.v.price.lte=29#pd-grid', on: /price\.gte=20/ },
    { g: 250, label: 'Extra small 250 g', href: '/collections/diwali?filter.v.price.lte=15#pd-grid', on: /price\.lte=15(?!\d)/ }
  ];
  /* U1: one suggestion per size, the first that is in stock and not already in the bag */
  var POOL = {
    250: ['extra-small-best-seller-diwali-box', 'extra-small-diwali-favourites-box', 'extra-small-mix-box-1', 'extra-small-motichoor-ladoo-box-diwali-special'],
    500: ['diwali-special-small-kaju-box', 'diwali-special-small-milky-box', 'small-mix-peda-diwali-box', 'small-mix-burfi-diwali-special-box', 'diwali-special-small-motichoor-box', 'small-syrup-soaker-diwali-box'],
    1000: ['diwali-special-classic-box', 'diwali-special-large-punjabi-box', 'diwali-special-boondi-ladoo-box', 'diwali-special-large-staff-selection-box', 'diwali-special-large-mix-burfi-box']
  };
  /* U2: ready-made sets. [CONFIRM with Abhi: which boxes, and the set names.] Prices are summed
     live from the product records, never typed, and no discount is applied (Rule 2). */
  var SETS = [
    { name: 'One big, one small', note: 'For two households', items: [['diwali-special-classic-box', 1], ['diwali-special-small-kaju-box', 1]] },
    { name: 'The big visit', note: 'Two large and one small', items: [['diwali-special-large-punjabi-box', 1], ['diwali-special-boondi-ladoo-box', 1], ['small-mix-burfi-diwali-special-box', 1]] },
    { name: 'One for everyone at work', note: 'Eight extra small boxes', items: [['extra-small-best-seller-diwali-box', 4], ['extra-small-diwali-favourites-box', 4]] }
  ];
  /* D5: real customer words already published on the homepage testimonials (verbatim sentences). */
  var QUOTES = [
    ['Ordered the Diwali Staff Selection box and the taste matched or beat the famous North Indian shops.', 'Hitesh Sharma', 'October 2024'],
    ['Delicious sweets, beautiful packaging, amazing customer service and interstate delivery was on time.', 'Aditi Sharma', 'October 2022'],
    ['We’ve received sweets from here as gifts multiple times now. Each time they’ve been so fresh and delicious.', 'Jowveria Mufti', 'March 2022']
  ];

  var PROD = {};
  function prod(h) {
    if (PROD[h]) return PROD[h];
    PROD[h] = fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return null;
        var v = p.variants[0];
        return { h: h, title: p.title, vid: v.id, price: v.price, avail: !!v.available, img: p.featured_image,
                 g: (typeof v.weight === 'number') ? v.weight : null, any: (p.tags || []).indexOf('Any Order') > -1 };
      })
      .catch(function () { return null; });
    return PROD[h];
  }

  /* ---------- cart ---------- */
  function cart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function bagMode(c) {
    try { if (w.PDDiwaliMode && w.PDDiwaliMode.resolveMode) return w.PDDiwaliMode.resolveMode(c.items); } catch (_) {}
    return (d.body && d.body.getAttribute('data-pd-mode')) || 'none';
  }
  function lockNote(m) {
    return m === 'mixed'
      ? 'Your bag has Diwali and everyday items together. Sort the bag out first.'
      : 'Your bag has everyday items. Diwali boxes go on their own order, so check out or empty that bag first.';
  }
  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || (j && j.status >= 400)) throw new Error((j && (j.description || j.message)) || 'add failed');
        return j;
      });
    });
  }
  function addDiwali(lines) {
    return cart().then(function (c) {
      var m = bagMode(c);
      if (m === 'everyday' || m === 'mixed') { var e = new Error('mode'); e.mode = m; throw e; }
      return postAdd(lines.map(function (l) { return { id: l.id, quantity: l.quantity, properties: PROP }; }));
    });
  }
  /* pantry lines carry their own stamp: "any" for products tagged Any Order (same as the existing
     pantry form), nothing otherwise. A product without Any Order is refused in a Diwali or mixed bag. */
  function addPantry(lines) {
    return cart().then(function (c) {
      var m = bagMode(c);
      var needsEveryday = lines.some(function (l) { return !l.any; });
      if (needsEveryday && (m === 'diwali' || m === 'mixed')) { var e = new Error('mode'); e.mode = m; throw e; }
      return postAdd(lines.map(function (l) { var o = { id: l.id, quantity: l.quantity }; if (l.any) o.properties = { _order_type: 'any' }; return o; }));
    });
  }
  /* The theme's own refresh (component-product-form.js does exactly this after an ajax add). */
  function afterAdd(vids) {
    store('pdqw-new', JSON.stringify(vids || []));
    if (is('cart')) {
      store('pdqw-y', String(w.pageYOffset || 0));
      var te = $('.cart-section .cart__details .cart__total strong'), tc = te ? cents(te.textContent) : null;
      if (tc != null) store('pdqw-total0', String(tc));   /* CR5: the reloaded page rolls from this */
      location.reload(); return Promise.resolve();
    }
    return fetch('?section_id=helper-cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var nf = doc.getElementById('AjaxCartForm'), ns = doc.getElementById('AjaxCartSubtotal');
        var cf = d.getElementById('AjaxCartForm'), cs = d.getElementById('AjaxCartSubtotal');
        if (cf && nf) { cf.innerHTML = nf.innerHTML; if (typeof cf.ajaxifyCartItems === 'function') cf.ajaxifyCartItems(); }
        if (cs && ns) cs.innerHTML = ns.innerHTML;
        var cnt = doc.querySelector('[data-cart-count]'), tot = doc.querySelector('[data-cart-total]');
        $$('[data-header-cart-count]').forEach(function (x) { if (cnt) x.textContent = cnt.textContent; });
        $$('[data-header-cart-total]').forEach(function (x) { if (tot) x.textContent = tot.textContent; });
        var cfEl = $('cart-form');
        (cfEl || d).dispatchEvent(new Event('cart-updated'));
        var dr = d.getElementById('site-cart-sidebar');
        if (dr) { dr.classList.remove('cart-is-empty'); if (typeof dr.show === 'function') dr.show(); }
        markNew();
      });
  }
  function bindAdd(btn, lines, msg, adder) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-working')) return;
      var orig = btn.innerHTML;
      btn.classList.add('is-working'); btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding…';
      if (msg) msg.textContent = '';
      (adder || addDiwali)(lines)
        .then(function () { btn.textContent = '✓ Added'; btn.classList.add('is-done'); return afterAdd(lines.map(function (l) { return l.id; })); })
        .catch(function (e) {
          btn.innerHTML = orig;
          if (msg) msg.textContent = e && e.mode ? lockNote(e.mode) : 'That did not go into your bag. Please try again.';
        })
        .then(function () {
          btn.classList.remove('is-working'); btn.removeAttribute('aria-busy');
          setTimeout(function () { if (btn.classList.contains('is-done')) { btn.innerHTML = orig; btn.classList.remove('is-done'); } }, 1800);
        });
    });
  }

  /* ---------- A1: the line you just added glows once in the bag ---------- */
  var pendingNew = [];
  function markNew() {
    var ids = pendingNew.slice();
    try { var s = JSON.parse(store('pdqw-new') || '[]'); ids = ids.concat(s); } catch (_) {}
    if (!ids.length) return;
    var hit = false;
    ids.forEach(function (id) {
      var row = d.getElementById('item-' + id);
      if (!row) return;
      hit = true;
      if (RM) return;
      row.classList.remove('pdqw-new'); void row.offsetWidth; row.classList.add('pdqw-new');
      setTimeout(function () { row.classList.remove('pdqw-new'); }, 1700);
    });
    if (hit) { pendingNew = []; store('pdqw-new', null); }
  }
  function watchAdds() {
    /* the theme's product form fires a non-bubbling "add-to-cart" on itself after a good add */
    d.addEventListener('add-to-cart', function (e) {
      var f = e.target && e.target.closest ? e.target.closest('form') : null;
      var id = f && f.querySelector('[name="id"]');
      if (id && id.value) pendingNew.push(id.value);
    }, true);
    var form = d.getElementById('AjaxCartForm');
    if (form && w.MutationObserver) new MutationObserver(function () { setTimeout(markNew, 30); pantryRows(); }).observe(form, { childList: true });
    if (is('cart')) setTimeout(markNew, 250);
  }

  /* ---------- U1 + A2: one more box, and the jar line fills ---------- */
  var giftTimer = 0;
  function giftRows() {
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () {
      if (!$('.pd-tea-cart') && !$('.cart__details > .cart__total')) return; /* no bag on this page: no fetch */
      cart().then(function (c) {
        var anchors = $$('.pd-tea-cart');
        var jar = anchors.length > 0;
        anchors.forEach(jarBar);
        if (bagMode(c) !== 'diwali' || !c.item_count) return;
        if (!jar) anchors = $$('.cart__details > .cart__total');
        var inBag = {};
        c.items.forEach(function (it) { inBag[it.handle] = true; });
        anchors.forEach(function (a) {
          var gap = null;
          if (jar) {
            var m = a.textContent.replace(/,/g, '').match(/Add\s*\$([\d.]+)\s*more/i);
            gap = m ? Math.round(parseFloat(m[1]) * 100) : 0;
          }
          /* CF4: drawer -> the slot under the button; /cart keeps its place (pd-qw.css moves it on phones) */
          if (a.closest && a.closest('#site-cart-sidebar')) {
            var slot = drawerSlot('add');
            if (!slot || slot.querySelector('.pdqw-add')) return;
            buildGift(slot, inBag, gap, true);
            return;
          }
          if (a.nextElementSibling && a.nextElementSibling.classList.contains('pdqw-add')) return;
          buildGift(a, inBag, gap);
        });
      }).catch(function () {});
    }, 120);
  }
  function buildGift(anchor, inBag, gap, into) {
    var picks = [250, 500, 1000].map(function (g) {
      var list = POOL[g].filter(function (h) { return !inBag[h]; });
      return list.length ? list : [];
    });
    var host = el('div', 'pdqw-add');
    host.setAttribute('role', 'group');
    host.setAttribute('aria-label', 'Add another Diwali box');
    if (into) anchor.appendChild(host); else anchor.parentNode.insertBefore(host, anchor.nextSibling);
    Promise.all(picks.map(function (list) {
      return Promise.all(list.map(prod)).then(function (ps) { return ps.filter(function (p) { return p && p.avail; })[0] || null; });
    })).then(function (ps) {
      ps = ps.filter(Boolean);
      if (!ps.length) { host.parentNode && host.parentNode.removeChild(host); return; }
      /* only promise the jar when one of these boxes really closes the gap */
      var closes = gap > 0 && ps.some(function (p) { return p.price >= gap; });
      var head = gap > 0 ? (closes ? 'One more box gets you the jar' : 'Add a box, get closer to the jar') : 'Another household on your list?';
      var html = '<p class="pdqw-add__h">' + esc(head) + '</p><ul class="pdqw-add__list">';
      ps.forEach(function (p) {
        var g = GRAMS[p.h] || (/extra\s*small/i.test(p.title) ? 250 : (/small/i.test(p.title) ? 500 : 1000));
        var gets = gap > 0 && p.price >= gap;
        html += '<li class="pdqw-add__it' + (gets ? ' is-jar' : '') + '">'
          + '<a class="pdqw-add__img" href="/products/' + esc(p.h) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(imgUrl(p.img, 180)) + '" alt="" width="90" height="90" loading="lazy"></a>'
          + '<a class="pdqw-add__n" href="/products/' + esc(p.h) + '">' + esc(short(p.title)) + '</a>'
          + '<span class="pdqw-add__s">' + esc(sizeText(g)) + ' · ' + money(p.price) + '</span>'
          + (gets ? '<span class="pdqw-add__jar">Gets the jar</span>' : '')
          + '<button type="button" class="pdqw-add__b" data-vid="' + p.vid + '" aria-label="Add ' + esc(short(p.title)) + ' to your bag">Add</button>'
          + '</li>';
      });
      html += '</ul><p class="pdqw-add__msg" aria-live="polite"></p>';
      host.innerHTML = html;
      var msg = $('.pdqw-add__msg', host);
      $$('.pdqw-add__b', host).forEach(function (b) { bindAdd(b, [{ id: +b.getAttribute('data-vid'), quantity: 1 }], msg); });
    });
  }
  function jarBar(line) {
    if (!line || line.querySelector('.pdqw-bar')) return;
    var txt = line.textContent.replace(/,/g, '');
    var m = txt.match(/Add\s*\$([\d.]+)\s*more/i);
    var p = m ? Math.max(0, Math.min(1, (JAR_CENTS - parseFloat(m[1]) * 100) / JAR_CENTS)) : (/included/i.test(txt) ? 1 : null);
    if (p === null) return;
    var bar = el('span', 'pdqw-bar', '<i></i>');
    bar.setAttribute('aria-hidden', 'true');
    line.appendChild(bar);
    var fill = bar.firstChild;
    var prev = parseFloat(store('pdqw-jar-p'));
    if (isNaN(prev) || RM) prev = p;
    fill.style.transform = 'scaleX(' + prev + ')';
    store('pdqw-jar-p', String(p));
    if (p >= 1) line.classList.add('pdqw-got');
    if (prev !== p) {
      void fill.offsetWidth;
      w.requestAnimationFrame(function () { fill.style.transform = 'scaleX(' + p + ')'; });
      if (p >= 1 && prev < 1 && !RM) { line.classList.add('pdqw-got-now'); setTimeout(function () { line.classList.remove('pdqw-got-now'); }, 900); }
    }
  }
  /* ---------- U6: "From the pantry" in the drawer (every bag) and on /cart for Diwali bags ----------
     Abhi, 25 Sep: "I also want the pantry upsell in the cart or cart drawer". The theme's own pantry
     block (pd-cart-upsell-collection, collection "pantry") renders on /cart for everyday bags only;
     on 12 Sep it was hidden for Diwali bags wholesale. All six pantry products are tagged Any Order
     (checked 25 Sep), so they may ride in a Diwali order. Rules kept here:
     - Diwali bag: only Any Order products are offered, each stamped _order_type=any.
     - Mixed bag: nothing is offered. Everything already in the bag is skipped.
     - While the free-jar line shows, the paid Masala Chai jar is not offered beside it.
     - On /cart for an everyday bag the theme's own block stays; this adds nothing there. */
  var TEA = 'tea-blend-masala-chai';
  var pantryP = null, pantryTimer = 0;
  function pantryList() {
    if (pantryP) return pantryP;
    pantryP = fetch('/collections/pantry/products.json?limit=12', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        return (j.products || []).map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return null;
          var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(/\s*,\s*/);
          return { h: p.handle, title: p.title, any: tags.indexOf('Any Order') > -1, vid: v.id,
                   price: Math.round(parseFloat(v.price) * 100), vt: p.variants.length > 1 ? v.title : '',
                   img: (p.images && p.images[0] && p.images[0].src) || '' };
        }).filter(Boolean);
      })
      .catch(function () { return []; });
    return pantryP;
  }
  function pantryRows() {
    clearTimeout(pantryTimer);
    pantryTimer = setTimeout(function () {
      /* CF4: drawer -> the slot under the button; /cart phones -> after the pay block; /cart wider
         screens -> under the items, as before. into = append inside the target, else insert after it. */
      var anchors = [];
      if (!is('cart')) { var ds = drawerSlot('pantry'); if (ds) anchors.push({ a: ds, into: true }); }
      else if (!$('.pd-cart-upsell-col')) {
        var pa = PHONE() ? $('.cart-section #AjaxCartSubtotal') : $('.cart-section > main > div:first-child');
        if (pa) anchors.push({ a: pa, into: false });
      }
      if (!anchors.length) return;
      var hostOf = function (t) {
        var n = t.into ? t.a.querySelector(':scope > .pdqw-pantry') : t.a.nextElementSibling;
        return (n && n.classList.contains('pdqw-pantry')) ? n : null;
      };
      Promise.all([cart(), pantryList()]).then(function (r) {
        var c = r[0], ps = r[1], m = bagMode(c);
        var clear = function () { anchors.forEach(function (t) { var n = hostOf(t); if (n) n.parentNode.removeChild(n); }); };
        if (!c.item_count || m === 'mixed' || !ps.length || (is('cart') && m !== 'diwali')) { clear(); return; }
        var inBag = {};
        c.items.forEach(function (it) { inBag[it.handle] = true; });
        var jarOn = !!$('.pd-tea-cart');
        var pick = ps.filter(function (p) { return !inBag[p.h] && (m !== 'diwali' || p.any) && !(jarOn && p.h === TEA); }).slice(0, 3);
        if (!pick.length) { clear(); return; }
        var key = pick.map(function (p) { return p.vid; }).join(',');
        anchors.forEach(function (t) {
          var host = hostOf(t);
          if (host) { if (host.getAttribute('data-key') === key) return; }
          else {
            host = el('div', 'pdqw-pantry'); host.setAttribute('role', 'group'); host.setAttribute('aria-label', 'From the pantry');
            if (t.into) t.a.appendChild(host); else t.a.parentNode.insertBefore(host, t.a.nextSibling);
          }
          host.setAttribute('data-key', key);
          var html = '<div class="pdqw-pantry__head"><p class="pdqw-pantry__h">From the pantry</p><p class="pdqw-pantry__sub">For your own table. It goes in this same order.</p></div><ul class="pdqw-pantry__rows">';
          pick.forEach(function (p) {
            html += '<li class="pdqw-pantry__row">'
              + '<a class="pdqw-pantry__thumb" href="/products/' + esc(p.h) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(imgUrl(p.img, 160)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>'
              + '<span class="pdqw-pantry__text"><a class="pdqw-pantry__t" href="/products/' + esc(p.h) + '">' + esc(p.title) + '</a>'
              + '<span class="pdqw-pantry__p">' + (p.vt ? esc(p.vt) + ' · ' : '') + money(p.price) + '</span></span>'
              + '<button type="button" class="pdqw-pantry__b" data-vid="' + p.vid + '" data-any="' + (p.any ? '1' : '') + '" aria-label="Add ' + esc(p.title) + ' to your order">Add</button>'
              + '</li>';
          });
          html += '</ul><p class="pdqw-pantry__msg" aria-live="polite"></p>';
          host.innerHTML = html;
          var msg = $('.pdqw-pantry__msg', host);
          $$('.pdqw-pantry__b', host).forEach(function (b) {
            bindAdd(b, [{ id: +b.getAttribute('data-vid'), quantity: 1, any: !!b.getAttribute('data-any') }], msg, addPantry);
          });
        });
      }).catch(function () {});
    }, 160);
  }
  /* CF4: on phones the theme's own pantry block (everyday bags) moves after the pay block too.
     It is a plain form, so moving the node keeps it working; it is not re-rendered by the theme. */
  function phoneCartOrder() {
    if (!is('cart') || !PHONE()) return;
    var col = $('.pd-cart-upsell-col'), sub = $('.cart-section #AjaxCartSubtotal');
    if (col && sub && sub.nextElementSibling !== col) sub.parentNode.insertBefore(col, sub.nextSibling);
  }
  function watchSubtotals() {
    if (!w.MutationObserver) return;
    $$('#AjaxCartSubtotal').forEach(function (s) {
      new MutationObserver(function () {
        safe(function () { totals(false); });
        giftRows();
        pantryRows();
        phoneCartOrder();
        if (is('cart')) { var tb = termsBox(); STEP.terms = !!(tb && tb.checked); paintSteps(); bindWatch(); readDate(); }
      }).observe(s, { childList: true });
    });
    giftRows();
  }

  /* ---------- A3 + U4: the cart page knows which step you are on ---------- */
  var STEP = { date: false, terms: false, read: false };
  var TICK = '<svg viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="12" r="10.25"/><path d="M7.2 12.4l3.1 3.1 6.6-6.7"/></svg>';
  function stepHosts() {
    return [
      $('.cart-section > main > div:first-child'),
      $('.cart-section > main > div.margin-bottom--regular'),
      $('#AjaxCartSubtotal .cart__subtotal-widget')
    ];
  }
  function paintSteps() {
    var done = [true, STEP.date, STEP.terms];
    stepHosts().forEach(function (h, i) {
      if (!h) return;
      h.classList.add('pdqw-step');
      var t = h.querySelector(':scope > .pdqw-tick');
      if (!t) { t = el('span', 'pdqw-tick', TICK); t.setAttribute('aria-hidden', 'true'); h.appendChild(t); }
      t.classList.toggle('is-done', !!done[i]);
    });
    paintBar();
    safe(coLabel);
    safe(appDateNote);
  }

  /* ---------- [R12-2] 5 Oct 2026 (Abhi: "do 1 and 2 on the preview"): a checkout button that says what comes first ----------
     Bag tracker, 28 Sep – 5 Oct: 59% of desktop and 40% of phone checkout taps came before pickup or delivery was chosen, and
     of the 91 sessions that tapped with no date only 49% went on to confirm (94% of those who had a date). The button kept
     saying "Proceed to Checkout" while Bird stopped it. Now, once Bird has drawn its chooser and the bag has no date, the
     button says "Choose pickup or delivery first"; a tap still goes through Bird (which scrolls to its block) and CR2's notes,
     and step 2 gets a brief ring. It says "Proceed to Checkout" again the moment the date is in the cart. Bird is only read. */
  function coLabel() {
    var co = d.getElementById('CheckOut'); if (!co || !STEP.read) return;
    if (!co.hasAttribute('data-pd-label')) co.setAttribute('data-pd-label', (co.textContent || '').trim() || 'Proceed to Checkout');
    var next = !STEP.date && !!$('#birdchime-slots-box .bird-method-tab');
    var want = next ? 'Choose pickup or delivery first' : co.getAttribute('data-pd-label');
    if ((co.textContent || '').trim() !== want) co.textContent = want;
    co.classList.toggle('pdqw-co--next', next);
  }
  function attn() {
    var b = d.getElementById('birdchime-slots-box'); if (!b) return;
    var app = b.closest('.shopify-app-block') || b;
    app.classList.remove('pdqw-attn'); void app.offsetWidth; app.classList.add('pdqw-attn');
    clearTimeout(attn.t); attn.t = setTimeout(function () { app.classList.remove('pdqw-attn'); }, 1800);
  }

  /* ---------- [R12-1] 5 Oct 2026: help at the date step for Instagram and Facebook shoppers ----------
     Bag tracker, 28 Sep – 5 Oct: after choosing pickup or delivery, 72% of bags in Facebook's browser and 65% in Instagram's
     went on to a date, against 97% in a normal browser. CR3's "open this bag in your browser" note sat by the checkout button,
     below the step where they stall. A compact copy now sits in step 2 under Bird's block while no date is set (in those apps
     only); the page address already carries the bag (CR3), so the app's own "Open in browser" brings it along. */
  function appDateNote() {
    if (!inApp()) return;
    var s2 = birdStep(), n = $('.pdqw-app2');
    if (!s2 || STEP.date || !$('#birdchime-slots-box .bird-method-tab')) { if (n && n.parentNode) n.parentNode.removeChild(n); return; }
    if (n) return;
    n = el('div', 'pdqw-app2');
    n.setAttribute('role', 'note');
    n.innerHTML = '<p class="pdqw-app2__h">Trouble picking a date in ' + appName() + '?</p>'
      + '<p class="pdqw-app2__t">Open this bag in your phone’s browser: tap <b>···</b> at the top of the screen, then <b>Open in browser</b>. Your bag comes with you.</p>'
      + '<button type="button" class="pdqw-app2__b">Copy the link to your bag</button>'
      + '<p class="pdqw-app2__msg" aria-live="polite"></p>';
    s2.appendChild(n);
    var btn = $('.pdqw-app2__b', n), msg = $('.pdqw-app2__msg', n);
    btn.addEventListener('click', function () {
      cart().then(function (c) {
        var full = location.origin + bagUrl(c);
        return copyText(full).then(function () { msg.textContent = 'Copied. Paste it into Safari or Chrome.'; }, function () {
          msg.innerHTML = 'Copy this link and paste it into Safari or Chrome:<input class="pdqw-app__url" readonly value="' + esc(full) + '">';
          var i = $('input', msg); if (i) { i.focus(); i.select(); }
        });
      }).catch(function () {});
    });
  }
  /* [R12-1] the calendar opens on October, which holds only the last two pre-order days; most Diwali dates are in November.
     While it is open on October (Diwali bags), a small line at the foot of the screen says so. Bird is only read. */
  var calTipEl = null;
  function calTip() {
    var f = $('.bird-date-picker__flyout'), m = f && $('.bird-date-grid__month', f), cs = f && w.getComputedStyle(f);
    var open = !!(f && f.getClientRects().length && cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity !== 0);
    var on = open && d.body.getAttribute('data-pd-mode') === 'diwali' && /october/i.test(m ? m.textContent : '');
    if (on && !calTipEl) {
      calTipEl = el('p', 'pdqw-caltip', 'Diwali is Sunday 8 November. Tap the <b>›</b> arrow on the calendar for November dates.');
      calTipEl.setAttribute('role', 'status');
      d.body.appendChild(calTipEl);
      w.requestAnimationFrame(function () { if (calTipEl) calTipEl.classList.add('is-on'); });
    } else if (!on && calTipEl) {
      var t = calTipEl; calTipEl = null; t.classList.remove('is-on');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, RM ? 0 : 260);
    }
  }
  function readDate() {
    return cart().then(function (c) {
      var a = (c && c.attributes) || {};
      var has = function (k) { return !!(a[k] && String(a[k]).trim()); };
      /* pickup needs a time slot too; Bird writes the date once the slot is chosen */
      STEP.date = has('Delivery Date') && (a['Delivery Method'] !== 'Pick Up' || has('Delivery Time'));
      STEP.read = true;
      paintSteps();
      if (STEP.date) needOff();
      safe(function () { dvRow(c); });
      safe(function () { bagNote(c); });
    }).catch(function () {});
  }
  var bar, barBtn, barTotal, VIS = { s2: false, terms: false, co: true };
  function nextStep() { return !STEP.date ? 's2' : (!STEP.terms ? 'terms' : 'co'); }
  function paintBar() {
    if (!bar) return;
    var t = $('#AjaxCartSubtotal .cart__total strong');
    barTotal.textContent = t ? t.textContent.trim() : '';
    barBtn.textContent = !STEP.date ? 'Next: pick your date' : (!STEP.terms ? 'Next: confirm your order' : 'Go to checkout');
    /* only while the step it points to is off screen, so it never sits over Bird's calendar */
    var on = !VIS[nextStep()] && (w.pageYOffset || 0) > 160;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    barBtn.tabIndex = on ? 0 : -1;
  }
  function cartPage() {
    if (!is('cart') || !$('#CheckOut')) return;
    var y = parseInt(store('pdqw-y'), 10);
    if (!isNaN(y)) { store('pdqw-y', null); w.scrollTo(0, y); }
    /* the theme re-renders #AjaxCartSubtotal (terms box and checkout button included) on every
       quantity change, so listen by delegation and re-read the live node each time */
    STEP.terms = !!(termsBox() && termsBox().checked);
    d.addEventListener('change', function (e) {
      if (e.target && e.target === termsBox()) { STEP.terms = e.target.checked; paintSteps(); }
    }, true);
    /* Bird's calendar and time list open as pop-ups outside any wrapper we own, so after any tap
       on this page we re-read the cart a few times. Bird's own markup is never read. */
    var poll = [];
    function soon() {
      poll.forEach(clearTimeout);
      poll = [900, 2500, 5000].map(function (ms) { return setTimeout(readDate, ms); });
    }
    d.addEventListener('pointerup', soon, { capture: true, passive: true });
    d.addEventListener('keyup', function (e) { if (e.key === 'Enter' || e.key === ' ') soon(); }, true);
    d.addEventListener('visibilitychange', function () { if (!d.hidden) readDate(); });
    /* v4.8 moves everyday bags to Shipping by script (no tap) and Bird writes the method a moment later,
       so read again after load for CR1 */
    [1800, 4500].forEach(function (ms) { setTimeout(readDate, ms); });
    /* CR2: a checkout tap with step 2 unfinished gets its reason; Bird still does the stopping */
    d.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('#CheckOut') || STEP.date) return;
      safe(needOn);
      safe(attn);
      readDate();
    }, true);
    /* [R12-1] the calendar line: check after any tap (the calendar opens, turns a month, closes) */
    d.addEventListener('click', function () { setTimeout(function () { safe(calTip); }, 180); setTimeout(function () { safe(calTip); }, 600); }, true);
    /* [R12-2] the theme redraws #AjaxCartSubtotal (and the button) on every quantity change: label it again */
    var sub = d.getElementById('AjaxCartSubtotal');
    if (sub && w.MutationObserver) { var lt = 0; new MutationObserver(function () { clearTimeout(lt); lt = setTimeout(function () { safe(coLabel); }, 60); }).observe(sub, { childList: true, subtree: true }); }
    bar = el('div', 'pdqw-cbar', '<div class="pdqw-cbar__in"><span class="pdqw-cbar__t"><small>Total</small><b></b></span><button type="button" class="pdqw-cbar__b"></button></div>');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Your order, next step');
    d.body.appendChild(bar);
    barBtn = $('.pdqw-cbar__b', bar); barTotal = $('b', bar);
    barBtn.addEventListener('click', function () {
      var co = d.getElementById('CheckOut');
      var tb = termsBox();
      var tgt = !STEP.date ? stepHosts()[1] : (!STEP.terms ? ((tb && (tb.closest('terms-checkbox') || tb)) || co) : co);
      if (tgt) tgt.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: STEP.date ? 'center' : 'start' });
    });
    bindWatch();
    w.addEventListener('scroll', function () { if (bar) paintBar(); }, { passive: true });
    paintSteps();
    readDate();
  }
  function termsBox() { return d.getElementById('AgreeToTos-page') || $('terms-checkbox input[type="checkbox"]'); }
  var IOS = [];
  function bindWatch() {
    if (!is('cart') || !w.IntersectionObserver) return;
    IOS.forEach(function (o) { o.disconnect(); });
    IOS = [];
    var tb = termsBox();
    [['s2', stepHosts()[1]], ['terms', tb && (tb.closest('terms-checkbox') || tb)], ['co', d.getElementById('CheckOut')]].forEach(function (p) {
      if (!p[1]) return;
      var o = new IntersectionObserver(function (es) { VIS[p[0]] = es[0].isIntersecting; paintBar(); });
      o.observe(p[1]);
      IOS.push(o);
    });
  }

  /* ---------- CR1 (26 Sep 2026, Abhi: "build 1 and 2 and push live"): what the delivery fee covers ----------
     27 Aug to 25 Sep, checkouts that got as far as an email: 45% of delivery checkouts were abandoned
     against 9% of pickup ones, 67% under $40, and the median abandoned delivery basket was $54 against
     a $25 fee. The fee itself does not change (delivery runs at break-even: nothing discounted, nothing
     made free). On the Shipping choice, while the items come to under $60 inside the first weight band,
     the shopper sees that the one fee covers up to 4 kg, can add something that still fits the band,
     or can move to free pickup. It sits after Bird's block in step 2 (never inside it, never above its
     tabs), so nothing a shopper has just tapped moves. Rate card = PD_TIERS in pd-ux.js (0 to 4 kg $25). */
  var DV = { under: 6000, band: 4000, fee: 2500 }, dvSeq = 0;
  /* everyday picks: the best-selling single products of the last 60 days of online orders (read 26 Sep),
     all tagged Any Order, so each is stamped _order_type=any and may ride in either order type */
  var EVERY = ['pure-desi-mini-medly-slab', 'milk-cake-slab', 'mix-kaju-slab', 'chenna-murki-box',
               'masala-matar', 'gur-para', 'pure-desi-namak-para', 'pure-desi-methi-mathi'];
  var STORES = 'Arndell Park, Kellyville, Woodridge or Campbellfield';
  function birdStep() {
    return $$('.cart-section > main > div.margin-bottom--regular').filter(function (x) { return !!x.querySelector('.shopify-app-block, #birdchime-slots-box'); })[0] || null;
  }
  function kg(g) { return (Math.round(g / 100) / 10).toFixed(1) + ' kg'; }
  function jarGap() {
    var t = $('.cart-section .pd-tea-cart'); if (!t) return 0;
    var m = t.textContent.replace(/,/g, '').match(/Add\s*\$([\d.]+)\s*more/i);
    return m ? Math.round(parseFloat(m[1]) * 100) : 0;
  }
  function dvRow(c) {
    var s2 = birdStep(); if (!s2) return;
    var seq = ++dvSeq;
    var m = bagMode(c), a = (c && c.attributes) || {};
    if (!c || !c.item_count || (m !== 'diwali' && m !== 'everyday') || a['Delivery Method'] !== 'Shipping'
        || !(c.items_subtotal_price < DV.under) || !(c.total_weight < DV.band)) {
      var old = s2.querySelector(':scope > .pdqw-dv');
      if (old) old.parentNode.removeChild(old);
      d.body.classList.remove('pdqw-dv-on');
      return;
    }
    var room = DV.band - c.total_weight, inBag = {};
    c.items.forEach(function (it) { inBag[it.handle] = true; });
    /* p.g is the GROSS parcel weight Shopify rates on (a Large box is 1.2 kg), so it decides what fits but is
       never shown: the row shows the price, and a box's size is already in its name */
    var fits = function (p) { return !!(p && p.avail && !inBag[p.h] && p.g != null && p.g <= room); };
    var picks = m === 'diwali'
      ? Promise.all([250, 500, 1000].map(function (g) {
          return Promise.all(POOL[g].map(prod)).then(function (ps) { return ps.filter(fits)[0] || null; });
        }))
      : Promise.all(EVERY.map(prod)).then(function (ps) { return ps.filter(function (p) { return fits(p) && p.any; }).slice(0, 3); });
    picks.then(function (ps) {
      if (seq !== dvSeq) return;                        /* a newer read owns the row */
      ps = ps.filter(Boolean);
      var gap = m === 'diwali' ? jarGap() : 0;
      var key = [m, c.total_weight, gap].concat(ps.map(function (p) { return p.vid; })).join(',');
      var host = s2.querySelector(':scope > .pdqw-dv'), made = false;
      if (host && host.getAttribute('data-key') === key) return;
      if (!host) {
        made = true;
        host = el('div', 'pdqw-dv');
        host.setAttribute('role', 'group');
        host.setAttribute('aria-label', 'What your delivery fee covers');
        var app = s2.querySelector(':scope > .shopify-app-block');
        s2.insertBefore(host, app ? app.nextSibling : s2.querySelector(':scope > .pdqw-tick'));
      }
      host.setAttribute('data-key', key);
      var fee = '$' + (DV.fee / 100), used = Math.max(0.03, Math.min(1, c.total_weight / DV.band));
      var html = '<p class="pdqw-dv__h">Your ' + fee + ' delivery covers up to 4 kg</p>'
        + '<div class="pdqw-dv__meter" aria-hidden="true"><i></i></div>'
        + '<p class="pdqw-dv__sub">This order is ' + kg(c.total_weight) + '.'
        + (ps.length ? ' ' + (m === 'diwali' ? 'Add a box' : 'Add more') + ' and delivery stays <strong>' + fee + '</strong>.' : '') + '</p>';
      if (ps.length) {
        html += '<ul class="pdqw-pantry__rows">';
        ps.forEach(function (p) {
          var jar = gap > 0 && p.price >= gap;
          html += '<li class="pdqw-pantry__row">'
            + '<a class="pdqw-pantry__thumb" href="/products/' + esc(p.h) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(imgUrl(p.img, 160)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>'
            + '<span class="pdqw-pantry__text"><a class="pdqw-pantry__t" href="/products/' + esc(p.h) + '">' + esc(m === 'diwali' ? short(p.title) : p.title) + '</a>'
            + '<span class="pdqw-pantry__p">' + money(p.price) + (jar ? ' · <b class="pdqw-dv__jar">gets the jar</b>' : '') + '</span></span>'
            + '<button type="button" class="pdqw-pantry__b" data-vid="' + p.vid + '" aria-label="Add ' + esc(p.title) + ' to your order">Add</button>'
            + '</li>';
        });
        html += '</ul><p class="pdqw-pantry__msg" aria-live="polite"></p>';
      }
      html += '<p class="pdqw-dv__pick"><span>Near ' + STORES + '?</span><button type="button" class="pdqw-dv__pb">Pick up free instead</button></p>';
      host.innerHTML = html;
      /* it can arrive a second or two after load (everyday bags); if the shopper is already further down,
         keep what they are looking at (the total, the checkout button) where it was */
      if (made) { var hr = host.getBoundingClientRect(); if (hr.bottom <= 0) w.scrollBy(0, hr.height + 18); }
      var fill = $('.pdqw-dv__meter i', host);
      /* CR5: fills from where it was before this add, not from empty */
      var was = parseFloat(store('pdqw-dv-used')); store('pdqw-dv-used', used.toFixed(3));
      if (RM) fill.style.transform = 'scaleX(' + used.toFixed(3) + ')';
      else { fill.style.transform = 'scaleX(' + (isNaN(was) ? 0 : Math.min(was, used)).toFixed(3) + ')'; w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { fill.style.transform = 'scaleX(' + used.toFixed(3) + ')'; }); }); }
      var msg = $('.pdqw-pantry__msg', host);
      $$('.pdqw-pantry__b', host).forEach(function (b) {
        bindAdd(b, [{ id: +b.getAttribute('data-vid'), quantity: 1, any: true }], msg, m === 'diwali' ? addDiwali : addPantry);
      });
      $('.pdqw-dv__pb', host).addEventListener('click', function () { toPickup(c.token); });
      /* the Diwali boxes are offered here, so the same boxes do not show again by the total */
      d.body.classList.toggle('pdqw-dv-on', m === 'diwali' && ps.length > 0);
    });
  }
  function toPickup(token) {
    var box = d.getElementById('birdchime-slots-box'); if (!box) return;
    var tab = $$('.bird-method-tab', box).filter(function (t) { return /pick\s*up/i.test(t.textContent || ''); })[0];
    if (!tab) return;
    /* the shopper's own choice: the same flag a real tap sets in pd-diwali-mode.js, so the everyday
       Shipping default never taps it back */
    try { if (token) w.localStorage.setItem('pd-bird-method:' + token, 'user'); } catch (_) {}
    tab.click();
    var app = box.closest('.shopify-app-block') || box;
    app.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    setTimeout(readDate, 1200);
  }

  /* ---------- CR2 (26 Sep 2026): the reason, by the checkout button ----------
     Bird stops the checkout while step 2 is unfinished and scrolls to its own block, but nothing said
     why by the button (a Diwali pickup with no store tapped showed only a pink outline). A checkout tap
     with no date booked now puts the reason beside the button and at the top of step 2. Nothing is
     prevented or submitted here; Bird still decides. Both notes go as soon as the date is in the cart. */
  var NEED = 'Choose pick-up or delivery and your date first.';
  var NEED_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9.5"/><path d="M12 7.2v6"/><path d="M12 16.4v.4"/></svg>';
  function needOff() { $$('.pdqw-need').forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); }); }
  function needOn() {
    var co = d.getElementById('CheckOut'), s2 = birdStep();
    if (co && !co.parentNode.querySelector(':scope > .pdqw-need--btn')) {
      var p = el('p', 'pdqw-need pdqw-need--btn', NEED_ICON + '<span>' + NEED + ' <button type="button" class="pdqw-need__go">Go to step 2</button></span>');
      p.setAttribute('role', 'alert');
      co.parentNode.insertBefore(p, co);
      $('.pdqw-need__go', p).addEventListener('click', function () {
        var t = $('.pdqw-need--s2') || birdStep();
        if (t) t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
      });
    }
    if (s2 && !s2.querySelector(':scope > .pdqw-need')) {
      var b = el('p', 'pdqw-need pdqw-need--s2', NEED_ICON + '<span>' + NEED + ' Then tap checkout again.</span>');
      var app = s2.querySelector(':scope > .shopify-app-block');
      s2.insertBefore(b, app || s2.firstChild);
      /* after Bird's own scroll, bring the note into view above Bird's block */
      setTimeout(function () { if (b.parentNode) b.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); }, 420);
    }
  }

  /* ---------- CR3 (26 Sep 2026, Abhi: "build 3 and push live"): take the bag from Instagram or Facebook
     to the browser ----------
     27 Aug to 25 Sep: the Facebook and Instagram in-app browsers were 22% of sessions and added to cart more
     than anyone (17%), but only 18% of their checkouts were paid, against about 37% in Safari, where saved
     details and Apple Pay are to hand. On /cart inside those apps the page address carries the bag
     (?pd_bag=...), so the app's own "open in browser" menu, or the copied link, opens the same bag in the
     browser. There it is rebuilt through /cart/add.js on /cart, so Bird runs and the date is chosen there.
     Each line keeps its properties (the Diwali stamp, Any Order, build-your-own choices); Bird's own
     attributes are not carried (Bird is frozen). A browser that already holds a different bag is asked first.
     The link only ever ADDS to an empty bag or replaces one on the shopper's say-so; lines are validated. */
  var BAG_P = 'pd_bag';
  /* read once per page: the theme re-renders the subtotal block, so the note is put back from this */
  var bagMissed = store('pdqw-bag-missed'); if (bagMissed) store('pdqw-bag-missed', null);
  function inApp() { return /Instagram|FBAN|FBAV|FB_IAB|FBIOS|FB4A/i.test(navigator.userAgent || ''); }
  function appName() { return /Instagram/i.test(navigator.userAgent || '') ? 'Instagram' : 'Facebook'; }
  function b64e(t) { return w.btoa(unescape(encodeURIComponent(t))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function b64d(t) { t = String(t).replace(/-/g, '+').replace(/_/g, '/'); while (t.length % 4) t += '='; return decodeURIComponent(escape(w.atob(t))); }
  function lineProps(p) {
    var o = {}, n = 0;
    Object.keys(p || {}).sort().forEach(function (k) {
      if (k === '_BirdChimeSlotId' || p[k] == null || p[k] === '' || n >= 20 || k.length > 80) return;
      o[k] = String(p[k]).slice(0, 300); n++;
    });
    return o;
  }
  function bagUrl(c) {
    var lines = c.items.map(function (it) {
      var pr = lineProps(it.properties);
      return Object.keys(pr).length ? [it.variant_id, it.quantity, pr] : [it.variant_id, it.quantity];
    });
    return '/cart?' + BAG_P + '=' + b64e(JSON.stringify(lines));
  }
  function readBag(t) {
    try {
      var a = JSON.parse(b64d(t)), out = [];
      if (!Array.isArray(a) || !a.length || a.length > 30) return null;
      for (var i = 0; i < a.length; i++) {
        var l = a[i];
        if (!Array.isArray(l)) return null;
        var id = +l[0], q = +l[1];
        if (!(id > 0) || id % 1 || !(q > 0) || q > 99 || q % 1) return null;
        var o = { id: id, quantity: q };
        if (l[2] && typeof l[2] === 'object') { var pr = lineProps(l[2]); if (Object.keys(pr).length) o.properties = pr; }
        out.push(o);
      }
      return out;
    } catch (_) { return null; }
  }
  function sameBag(c, lines) {
    var key = function (id, q, p) { return id + ':' + q + ':' + JSON.stringify(lineProps(p)); };
    var a = c.items.map(function (it) { return key(it.variant_id, it.quantity, it.properties); }).sort().join('|');
    var b = lines.map(function (l) { return key(l.id, l.quantity, l.properties); }).sort().join('|');
    return a === b;
  }
  function dropParam(s, k) { return s.replace(new RegExp('([?&])' + k + '=[^&#]*(&|$)'), '$1').replace(/[?&]$/, ''); }
  function stripBag() {
    try { history.replaceState(history.state, '', location.pathname + dropParam(dropParam(location.search, BAG_P), 'pd_src') + location.hash); } catch (_) {}
  }
  /* CR3b (28 Sep 2026): the Diwali "bag left" email links here with &pd_src=email and the box the shopper chose.
     An email link never replaces a bag: if every box it carries is already in the bag, nothing happens; if the
     bag is missing one and adding it keeps a single order type, it is added; otherwise the same "Use that bag
     instead?" question as the app link. */
  function fromEmail() { return /[?&]pd_src=email(?:[&#]|$)/.test(location.search); }
  function missingLines(c, lines) {
    var have = {};
    (c.items || []).forEach(function (it) { have[it.variant_id] = true; });
    return lines.filter(function (l) { return !have[l.id]; });
  }
  function staysOneType(c, add) {
    var m = bagMode({ items: (c.items || []).concat(add.map(function (l) { return { properties: l.properties || {}, product_type: '' }; })) });
    return m !== 'mixed';
  }
  function fillBag(lines, clearFirst) {
    var start = clearFirst
      ? fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: '{}' })
      : Promise.resolve();
    return start
      .then(function () { return postAdd(lines); })
      .catch(function () {
        /* a line is no longer available: add the others one at a time and say so on the next page */
        var missed = 0;
        return lines.reduce(function (pr, l) { return pr.then(function () { return postAdd([l]).catch(function () { missed += l.quantity; }); }); }, Promise.resolve())
          .then(function () { if (missed) store('pdqw-bag-missed', String(missed)); });
      })
      .then(function () { location.replace(location.pathname); });
  }
  function askBag(lines) {
    var n = lines.reduce(function (t, l) { return t + l.quantity; }, 0);
    var dl = el('div', 'pd-switch pdqw-bagq');
    dl.setAttribute('role', 'dialog'); dl.setAttribute('aria-modal', 'true'); dl.setAttribute('aria-labelledby', 'pdqw-bagq-t');
    dl.innerHTML = '<div class="pd-switch__scrim" data-keep></div><div class="pd-switch__card">'
      + '<span class="pd-switch__eyebrow">The bag you opened</span>'
      + '<h2 id="pdqw-bagq-t" class="pd-switch__title">Use that bag instead?</h2>'
      + '<p class="pd-switch__body">This browser already has a different bag. The one you opened holds ' + n + (n === 1 ? ' item' : ' items') + '.</p>'
      + '<div class="pd-switch__actions"><button type="button" class="pd-switch__btn pd-switch__btn--solid" data-use>Use the bag I opened</button>'
      + '<button type="button" class="pd-switch__btn pd-switch__btn--outline" data-keep>Keep this bag</button></div>'
      + '<button type="button" class="pd-switch__close" data-keep aria-label="Close">&times;</button></div>';
    d.body.appendChild(dl);
    d.documentElement.classList.add('pd-switch-open');
    var close = function () { if (dl.parentNode) dl.parentNode.removeChild(dl); d.documentElement.classList.remove('pd-switch-open'); stripBag(); };
    $$('[data-keep]', dl).forEach(function (b) { b.addEventListener('click', close); });
    d.addEventListener('keydown', function esc(e) { if (e.key === 'Escape' && dl.parentNode) { close(); d.removeEventListener('keydown', esc); } });
    var use = $('[data-use]', dl);
    use.addEventListener('click', function () { use.classList.add('working'); fillBag(lines, true); });
    use.focus();
  }
  function bagIncoming() {
    if (!is('cart') || inApp()) return;
    var m = location.search.match(/[?&]pd_bag=([^&#]+)/);
    if (!m) return;
    var raw = null;
    try { raw = decodeURIComponent(m[1]); } catch (_) {}
    var lines = raw ? readBag(raw) : null;
    if (!lines) { stripBag(); return; }
    cart().then(function (c) {
      if (!c.item_count) { fillBag(lines, false); return; }
      if (sameBag(c, lines)) { stripBag(); return; }
      if (fromEmail()) {
        var miss = missingLines(c, lines);
        if (!miss.length) { stripBag(); return; }
        if (staysOneType(c, miss)) { fillBag(miss, false); return; }
      }
      askBag(lines);
    }).catch(stripBag);
  }
  function copyText(t) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t);
    return new Promise(function (res, rej) {
      var ta = d.createElement('textarea'); ta.value = t; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      d.body.appendChild(ta); ta.select();
      var ok = false; try { ok = d.execCommand('copy'); } catch (_) {}
      d.body.removeChild(ta); if (ok) res(); else rej();
    });
  }
  function bagNote(c) {
    var co = d.getElementById('CheckOut'), old = $('.pdqw-app');
    if (bagMissed && co && !$('.pdqw-need--missed')) {
      var mn = el('p', 'pdqw-need pdqw-need--missed', NEED_ICON + '<span>' + (bagMissed === '1' ? 'One item' : bagMissed + ' items') + ' from the bag you opened could not be added. It may have sold out.</span>');
      co.parentNode.insertBefore(mn, co.parentNode.querySelector(':scope > .pdqw-need--btn') || co);
    }
    if (!inApp()) return;
    if (!c || !c.item_count) { if (old) old.parentNode.removeChild(old); stripBag(); return; }
    var url = bagUrl(c);
    try { if (location.pathname + location.search !== url) history.replaceState(history.state, '', url); } catch (_) {}
    if (old) { old.setAttribute('data-url', url); return; }
    if (!co) return;
    var note = el('div', 'pdqw-app');
    note.setAttribute('role', 'note');
    note.setAttribute('data-url', url);
    note.innerHTML = '<p class="pdqw-app__h">Paying from ' + appName() + '?</p>'
      + '<p class="pdqw-app__t">It is often quicker in your phone’s browser, where your saved details are. Tap <b>···</b> at the top of the screen and choose to open this page in your browser. Your bag comes with you, and you choose your date there.</p>'
      + '<button type="button" class="pdqw-app__b">Copy the link to your bag</button>'
      + '<p class="pdqw-app__msg" aria-live="polite"></p>';
    co.parentNode.insertBefore(note, co.parentNode.querySelector(':scope > .pdqw-need--btn') || co);
    var nr = note.getBoundingClientRect(); if (nr.bottom <= 0) w.scrollBy(0, nr.height + 12);
    var btn = $('.pdqw-app__b', note), msg = $('.pdqw-app__msg', note);
    btn.addEventListener('click', function () {
      var full = location.origin + note.getAttribute('data-url');
      copyText(full).then(function () {
        msg.textContent = 'Copied. Paste it into Safari or Chrome.';
      }).catch(function () {
        msg.innerHTML = 'Copy this link and paste it into Safari or Chrome:<input class="pdqw-app__url" readonly value="' + esc(full) + '">';
        var inp = $('.pdqw-app__url', msg); if (inp) { inp.focus(); inp.select(); }
      });
    });
  }

  /* ---------- CR4 (26 Sep 2026, Abhi: "build 1, 2 and 3 and push live"): the pre-order countdown ----------
     snippets/pd-close-count.liquid prints the count (so nothing moves as the page loads) and holds the close moment.
     Here it is kept current (a page can come from cache) and its digits slide in once: the bar once per visit, the
     Diwali page's "Order by" block when it comes into view. Days until the last 72 hours, then hours. */
  function cdValue(end) {
    var left = end - Date.now();
    if (left <= 0) return null;
    if (left > 72 * 3600e3) { var dd = Math.floor(left / 86400e3); return [dd, dd === 1 ? 'day' : 'days']; }
    var h = Math.ceil(left / 3600e3); return [h, h === 1 ? 'hour' : 'hours'];
  }
  function closeCount() {
    $$('[data-pd-cd]').forEach(function (el) {
      var v = cdValue((+el.getAttribute('data-pd-close') || 0) * 1000);
      var bar = el.classList.contains('pd-cd--bar');
      if (!v) { if (bar) el.textContent = 'Pre-orders closed'; else el.hidden = true; return; }
      var n = $('.pd-cd__n', el), u = $('.pd-cd__u', el);
      if (!n || !u) return;
      n.textContent = String(v[0]); u.textContent = v[1];
      if (RM) return;
      /* the number is split into digit boxes only while it slides in, then goes back to plain text, so screen
         readers always hear "33", never "3 3" */
      var play = function () {
        n.innerHTML = String(v[0]).split('').map(function (ch, i) { return '<span class="pd-cd__d" style="--i:' + i + '">' + ch + '</span>'; }).join('');
        el.classList.add('is-in');
        setTimeout(function () { el.classList.remove('is-in'); n.textContent = String(v[0]); }, 1200);
      };
      if (bar) { if (store('pdcd-bar')) return; store('pdcd-bar', '1'); play(); return; }
      if (!w.IntersectionObserver) return;
      var io = new IntersectionObserver(function (es) { if (!es[0].isIntersecting) return; io.disconnect(); play(); }, { threshold: 0.8 });
      io.observe(el);
    });
  }

  /* ---------- CR5 (26 Sep 2026): the total rolls to its new value ----------
     When a one-tap add or a quantity change moves the total (cart page and drawer), the figure counts from the old
     amount to the new one in about 0.65 s. On /cart an add reloads the page, so afterAdd leaves the old total in
     sessionStorage. The tea-jar bar and the CR1 weight meter fill from their last value too. */
  var TOT = {};
  function cents(t) { var m = String(t || '').replace(/,/g, '').match(/\$\s*(\d+(?:\.\d{1,2})?)/); return m ? Math.round(parseFloat(m[1]) * 100) : null; }
  function rollTo(el, from, to) {
    /* [LP-1] the total keeps its small raised "$" (span.pd-cur) while it rolls, rolls whole dollars when the total has no
       cents, and ends on the exact markup it started from */
    var txt = el.textContent, html = el.innerHTML, m = txt.match(/^([^$]*\$)\s*[\d,]+(\.\d{1,2})?(.*)$/);
    if (!m || RM || from == null || from === to) return;
    var pre = m[1], dec = !!m[2], post = m[3], t0 = null, dur = 650, cur = !!el.querySelector('.pd-cur');
    var fmt = function (c) { return (dec ? (c / 100).toFixed(2) : String(Math.round(c / 100))).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var put = function (c) { if (cur) el.innerHTML = esc(pre.slice(0, -1)) + '<span class="pd-cur">$</span>' + fmt(c) + esc(post); else el.textContent = pre + fmt(c) + post; };
    put(from);
    var step = function (ts) {
      if (!el.isConnected) return;
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      if (k < 1) put(Math.round(from + (to - from) * e)); else el.innerHTML = html;
      if (k < 1) w.requestAnimationFrame(step);
    };
    w.requestAnimationFrame(step);
  }
  function totals(first) {
    $$('.cart__details .cart__total strong').forEach(function (el) {
      var k = el.closest('#site-cart-sidebar') ? 'drawer' : 'page', now = cents(el.textContent);
      if (now == null || el.__pdTot) return;
      el.__pdTot = true;
      var before = TOT[k];
      if (first && k === 'page') { var sv = parseInt(store('pdqw-total0'), 10); store('pdqw-total0', null); if (!isNaN(sv)) before = sv; }
      TOT[k] = now;
      if (before != null && before !== now) rollTo(el, before, now);
    });
  }

  /* ---------- D3 + U2 + D5 on the Diwali collection ---------- */
  function gridEl() { var c = $('.collection.grid > .product-item'); return c ? c.parentElement : null; }
  function cardGrams(card) { var t = card.querySelector('.pd-card-tag--diwali[data-pd-size]'); return t ? gramsOf(t.getAttribute('data-pd-size')) : 0; }
  function diwaliCollection() {
    if (!isDiwaliCollection()) return;
    var g = gridEl(); if (!g) return;
    var cards = $$('.collection.grid > .product-item');
    var shopperChose = /[?&](sort_by|filter\.)/.test(location.search) || /[?&]page=([2-9]|\d\d)/.test(location.search);
    var boxes = [], rest = [];
    cards.forEach(function (c, i) { var gr = cardGrams(c); (gr ? boxes : rest).push({ c: c, g: gr, i: i }); });
    /* D3: boxes first, largest to smallest, best-sellers order kept inside each size.
       On the live store this belongs in admin (collection sort = Manual); this is the preview of it. */
    if (!shopperChose && boxes.length && rest.length) {
      boxes.sort(function (a, b) { return (b.g - a.g) || (a.i - b.i); });
      var marker = d.createComment('pdqw');
      g.insertBefore(marker, cards[0]);
      var frag = d.createDocumentFragment();
      boxes.forEach(function (x) { frag.appendChild(x.c); });
      var band = el('div', 'pdqw-band', '<span class="pdqw-band__em">For your own Diwali table,</span><h2 class="pdqw-band__h">Sweets, snacks and extras</h2>');
      frag.appendChild(band);
      rest.forEach(function (x) { frag.appendChild(x.c); });
      g.insertBefore(frag, marker);
      g.removeChild(marker);
    }
    var ordered = boxes.map(function (x) { return x.c; });
    /* U2: sets after the third row of boxes; D5: one quote after the sixth */
    if (!shopperChose && ordered.length >= 6) sets(ordered[5]);
    if (ordered.length >= 12) quoteBand(ordered[11]);
    sizeBar();
  }
  function sets(after) {
    var wrap = el('div', 'pdqw-sets', '<div class="pdqw-sets__head"><span class="pdqw-sets__em">Buying for more than one house?</span><h2 class="pdqw-sets__h">Ready-made sets</h2></div><div class="pdqw-sets__row" role="list"></div>');
    after.parentNode.insertBefore(wrap, after.nextSibling);
    var row = $('.pdqw-sets__row', wrap);
    SETS.forEach(function (s) {
      var card = el('div', 'pdqw-set is-loading'); card.setAttribute('role', 'listitem');
      row.appendChild(card);
      Promise.all(s.items.map(function (it) { return prod(it[0]); })).then(function (ps) {
        if (ps.some(function (p) { return !p || !p.avail; })) { row.removeChild(card); if (!row.children.length) wrap.parentNode.removeChild(wrap); return; }
        var total = 0, count = 0, lines = [], names = [], thumbs = '';
        ps.forEach(function (p, i) {
          var q = s.items[i][1];
          total += p.price * q; count += q;
          lines.push({ id: p.vid, quantity: q });
          names.push((q > 1 ? q + ' × ' : '') + short(p.title));
          thumbs += '<img src="' + esc(imgUrl(p.img, 200)) + '" alt="" width="100" height="100" loading="lazy">';
        });
        card.className = 'pdqw-set';
        card.innerHTML = '<div class="pdqw-set__thumbs">' + thumbs + '</div>'
          + '<p class="pdqw-set__note">' + esc(s.note) + '</p>'
          + '<h3 class="pdqw-set__name">' + esc(s.name) + '</h3>'
          + '<p class="pdqw-set__list">' + esc(names.join(' · ')) + '</p>'
          + '<button type="button" class="pdqw-set__btn">Add all ' + count + ' · ' + money(total) + '</button>'
          + '<p class="pdqw-set__msg" aria-live="polite"></p>';
        bindAdd($('button', card), lines, $('.pdqw-set__msg', card));
      });
    });
  }
  function quoteHTML(q) {
    return '<figure class="pdqw-rev__q"><blockquote>“' + esc(q[0]) + '”</blockquote><figcaption>' + esc(q[1]) + ' · ' + esc(q[2]) + '</figcaption></figure>';
  }
  function quoteBand(after) {
    var b = el('div', 'pdqw-rev pdqw-rev--band', '<p class="pdqw-rev__h">In their own words</p>' + quoteHTML(QUOTES[0]));
    after.parentNode.insertBefore(b, after.nextSibling);
  }

  /* ---------- U3: the size choice follows you down the Diwali collection ---------- */
  function sizeBar() {
    var hero = $('.pd-dw2'); var g = gridEl();
    if (!hero || !g || !w.IntersectionObserver) return;
    var q = location.search, any = /price\./.test(q);
    var html = '<nav class="pdqw-sizes" aria-label="Box size"><a href="/collections/diwali#pd-grid"' + (!any ? ' aria-current="true"' : '') + '>All sizes</a>';
    SIZE_LINKS.forEach(function (s) { html += '<a href="' + s.href + '" aria-label="' + esc(s.label) + ' boxes"' + (s.on.test(q) ? ' aria-current="true"' : '') + '>' + esc(sizeText(s.g)) + '</a>'; });
    html += '</nav>';
    var wrap = el('div', 'pdqw-sizes-wrap', html);
    d.body.appendChild(wrap);
    var heroOut = false, endIn = false;
    function paint() { var on = heroOut && !endIn; wrap.classList.toggle('is-on', on); wrap.setAttribute('aria-hidden', on ? 'false' : 'true'); $$('a', wrap).forEach(function (a) { a.tabIndex = on ? 0 : -1; }); }
    new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; paint(); }).observe(hero);
    var end = $('[id$="__diwali_story"]') || $('footer');
    if (end) new IntersectionObserver(function (es) { endIn = es[0].isIntersecting; paint(); }, { rootMargin: '0px 0px -30% 0px' }).observe(end);
    paint();
  }

  /* ---------- U5 + D5 on Diwali product pages ---------- */
  function productPage() {
    if (!is('product')) return;
    var form = $('form[action*="/cart/add"][data-pd-type="diwali"]'); if (!form) return;
    var pt = $('.product-text'); if (!pt) return;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); var h = m ? m[1] : '';
    var actions = $('.product-text > .product-actions');
    var wt = $('.pd-wi-inline__weight');
    var myG = GRAMS[h] || (wt ? gramsOf(wt.textContent) : 0);
    /* U5 */
    var fam = null;
    FAMILIES.forEach(function (f) { if (f.handles.indexOf(h) > -1) fam = f; });
    var box = el('div', 'pdqw-sz');
    /* [R11-2] 5 Oct 2026: the buy box now comes straight after the title (templates/product*.json), so "Other sizes" goes
       after What's inside instead of above the price */
    var wiBlock = $('.product-text .pd-wi-inline'); wiBlock = wiBlock && wiBlock.closest('.product-text > *');
    if (wiBlock) wiBlock.parentNode.insertBefore(box, wiBlock.nextSibling);
    else if (actions) actions.parentNode.insertBefore(box, actions);
    if (fam) {
      var others = fam.handles.filter(function (x) { return x !== h; });
      Promise.all(others.map(prod)).then(function (ps) {
        var html = '';
        ps.forEach(function (p) { if (!p) return; html += '<a class="pdqw-sz__p" href="/products/' + esc(p.h) + '" title="' + esc(p.title) + '"><b>' + esc(short(p.title)) + '</b><span>' + esc(sizeText(GRAMS[p.h] || 0)) + ' · ' + money(p.price) + '</span></a>'; });
        if (!html) { box.parentNode.removeChild(box); return; }
        box.innerHTML = '<p class="pdqw-sz__h">' + esc(fam.heading) + '</p><div class="pdqw-sz__row">' + html + '</div>';
      });
    } else if (myG) {
      var html = '';
      SIZE_LINKS.forEach(function (s) { if (s.g !== myG && !(myG > 1000 && s.g === 1000)) html += '<a class="pdqw-sz__p pdqw-sz__p--link" href="' + s.href + '"><b>' + esc(s.label) + ' boxes</b><span>See them all →</span></a>'; });
      if (html) box.innerHTML = '<p class="pdqw-sz__h">Other sizes</p><div class="pdqw-sz__row">' + html + '</div>';
      else box.parentNode && box.parentNode.removeChild(box);
    } else if (box.parentNode) box.parentNode.removeChild(box);
    /* D5: after the pickup/delivery card, never inside Bird's own block */
    var deliv = $$('.product-text > .product__subtitle').filter(function (x) { return /pick up free/i.test(x.textContent); })[0];
    var google = $('.product-text > .product__subtitle a[href*="google"], .product-text > .product__subtitle a[href*="g.page"]');
    var rev = el('section', 'pdqw-rev');
    rev.setAttribute('aria-label', 'What customers say');
    rev.innerHTML = '<p class="pdqw-rev__h">In their own words</p><div class="pdqw-rev__row">' + QUOTES.map(quoteHTML).join('') + '</div>'
      + (google ? '<a class="pdqw-rev__more" href="' + esc(google.getAttribute('href')) + '" target="_blank" rel="noopener">Read our Google reviews →</a>' : '');
    /* [R11-2] after What's inside and Other sizes, so nothing sits between the button and the box's contents */
    var revAfter = (box.parentNode ? box : null) || wiBlock;
    if (revAfter) revAfter.parentNode.insertBefore(rev, revAfter.nextSibling);
    else if (deliv) deliv.parentNode.insertBefore(rev, deliv.nextSibling);
    else if (actions) actions.parentNode.insertBefore(rev, actions.nextSibling);
  }

  /* ---------- A4: the box photo carries from the card into the product page ---------- */
  function morph() {
    if (RM || !(w.CSS && CSS.supports && CSS.supports('view-transition-name: none'))) return;
    d.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('.product-item a[href*="/products/"]') : null;
      if (!a) return;
      var card = a.closest('.product-item');
      var fig = card.classList.contains('pdqw-peek') ? card.querySelector('.product-item__image-figure--secondary') : card.querySelector('.product-item__image-figure--primary');
      if (!fig) return;
      $$('[data-pdqw-vt]').forEach(function (x) { x.style.viewTransitionName = ''; x.removeAttribute('data-pdqw-vt'); });
      d.documentElement.classList.add('pdqw-vt-out');   /* drops the product page's own name, so there is only ever one */
      fig.style.viewTransitionName = 'pd-hero';
      fig.setAttribute('data-pdqw-vt', '');
    }, true);
    w.addEventListener('pageshow', function () {
      d.documentElement.classList.remove('pdqw-vt-out');
      $$('[data-pdqw-vt]').forEach(function (x) { x.style.viewTransitionName = ''; x.removeAttribute('data-pdqw-vt'); });
    });
  }

  /* ---------- A5: on a phone, each Diwali card shows what is inside, once ---------- */
  function peek() {
    if (RM || !w.IntersectionObserver || !(w.matchMedia && w.matchMedia('(hover: none)').matches)) return;
    var targets = $$('.product-item .product-item__image--has-secondary').filter(function (m) { return !!m.closest('.product-item').querySelector('.pd-card-tag--diwali'); });
    if (!targets.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var card = en.target.closest('.product-item');
        var im = en.target.querySelector('.product-item__image-figure--secondary img');
        setTimeout(function () {
          if (!im) return;
          if (im.complete && im.naturalWidth) card.classList.add('pdqw-peek');
          else im.addEventListener('load', function () { card.classList.add('pdqw-peek'); });
        }, 1200);
      });
    }, { threshold: 0.6 });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- CR6 (28 Sep 2026, critique fix #2, Abhi: "parcel pairings"): "Add both" on small box pages ----------
     The row itself is drawn by snippets/pd-parcel-row.liquid (server side: this page's box is an everyday Gift Box or
     Slab under $40, the bag holds no Diwali pre-order, and each pick keeps the parcel under the 4 kg / $25 band).
     This only wires the buttons: one tap adds THIS box at the chosen variant and quantity plus the pairing, through
     the same adder as the cart's row (addPantry: stamps Any Order lines, refuses an everyday line into a Diwali bag),
     then the drawer opens with both. Nothing is discounted and the delivery fee is unchanged. */
  function parcelRow() {
    var row = $('.pdqw-parcel'); if (!row || !is('product')) return;
    var msg = $('.pdqw-pantry__msg', row), selfAny = row.getAttribute('data-pd-parcel-self-any') === '1';
    var mainForm = function () { return $('product-form form[action*="/cart/add"]') || $('form[action*="/cart/add"][data-type="add-to-cart-form"]'); };
    $$('[data-pd-parcel]', row).forEach(function (b) {
      var lines = [];
      /* registered before bindAdd's own listener, so the lines are current when it adds */
      b.addEventListener('click', function () {
        var f = mainForm(), id = f && f.querySelector('[name="id"]'), q = f && f.querySelector('[name="quantity"]');
        var qty = Math.max(1, Math.min(99, parseInt(q && q.value, 10) || 1));
        lines.length = 0;
        if (id && +id.value) lines.push({ id: +id.value, quantity: qty, any: selfAny });
        lines.push({ id: +b.getAttribute('data-pd-parcel'), quantity: 1, any: b.getAttribute('data-pd-parcel-any') === '1' });
      });
      bindAdd(b, lines, msg, addPantry);
    });
  }

  ready(function () {
    safe(watchAdds);
    safe(function () { totals(true); });
    safe(closeCount);
    safe(parcelRow);
    safe(watchSubtotals);
    safe(pantryRows);
    safe(bagIncoming);
    safe(cartPage);
    safe(phoneCartOrder);
    safe(diwaliCollection);
    safe(productPage);
    safe(morph);
    safe(peek);
  });
})();
